import { jsxs as e, jsx as i } from "react/jsx-runtime";
function h(t) {
  return /* @__PURE__ */ e("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", ...t, children: [
    /* @__PURE__ */ i("g", { clipPath: "url(#clip0_2337_22541)", children: /* @__PURE__ */ i(
      "path",
      {
        d: "M23.4988 12C23.4988 5.64855 18.3506 0.5 11.9994 0.5C5.64829 0.5 0.5 5.64855 0.5 12C0.5 17.3935 4.21316 21.9188 9.22116 23.1619V15.5144H6.84998V12H9.22116V10.4855C9.22116 6.57085 10.9921 4.7573 14.8352 4.7573C15.5642 4.7573 16.8211 4.8999 17.3352 5.0425V8.228C17.0638 8.19925 16.5923 8.18545 16.007 8.18545C14.1211 8.18545 13.3932 8.8996 13.3932 10.7569V12H17.1489L16.5037 15.5144H13.3932V23.4161C19.0865 22.7284 23.5 17.88 23.5 12H23.4988Z",
        fill: "white"
      }
    ) }),
    /* @__PURE__ */ i("defs", { children: /* @__PURE__ */ i("clipPath", { id: "clip0_2337_22541", children: /* @__PURE__ */ i("rect", { fill: "white", height: "24", width: "24" }) }) })
  ] });
}
export {
  h as default
};
